export let PAGINACAO = {
  _ITENS_POR_PAGINA_DEFAULT: 10,
  ITENS_POR_PAGINA_POPUP: 10,
  ITENS_POR_PAGINA_MIN: 5,
  ITENS_POR_PAGINA_MAX: 30,
  ITENS_SEM_PAGINACAO: 99999999, //Listagem sem passar a page na URL

  get ITENS_POR_PAGINA_DEFAULT() {
    return this._ITENS_POR_PAGINA_DEFAULT;
  },

  set ITENS_POR_PAGINA_DEFAULT(value) {
    this._ITENS_POR_PAGINA_DEFAULT = value;
  },
};

/*
 * Obtém a qtde de registros por página para realizar a paginação,
 * assumindo a parametrização default quando não recebe o limit como parâmetro
 */
export function fn_getLimit(page, limit) {
  let limitRet = limit;

  if (page == 0) {
    limitRet = PAGINACAO.ITENS_SEM_PAGINACAO;
  } else {
    if (!limit || limit == 0) {
      limitRet = PAGINACAO.ITENS_POR_PAGINA_DEFAULT;
    }
  }
  return Number(limitRet);
}

/*
 * Retorna os dados paginados
 */
export function fn_getResultPaginado(page, result, limit) {
  if (result && result.length > 0) {
    //Obtém o limite no caso de precisar pegar o padrão
    const limitPage = fn_getLimit(page, limit);

    // Calcular o índice inicial e final dos itens da página atual
    const startIndex = (page - 1) * limitPage;
    const endIndex = startIndex + limitPage;

    // Filtrar os itens correspondentes à página atual
    const resultPage = result.slice(startIndex, endIndex);

    const pages = Math.ceil(result.length / limitPage);

    return {
      pages: pages,
      count: result.length,
      items: resultPage,
      limit: limitPage,
      offset: (page - 1) * limitPage,
    };
  } else {
    return {
      pages: 0,
      count: 0,
      items: [],
      limit: PAGINACAO.ITENS_POR_PAGINA_DEFAULT,
      offset: 0,
    };
  }
}
